module.exports = __webpack_public_path__ + "static/media/img_homepage_menu_05-Ourevent_active.023cd433.png";